export default new class Account {
  constructor() {
    this.eventName = 'dialog-wait';
    const that = this;

    $('.link__fb').on('click', () => {
      oc.ajax('Login::onSocialiteLogin', {
        data: { driver: 'facebook' },
        beforeSend() {
          that.waiting();
        },
      });
    });

    $('.link__google').on('click', () => {
      oc.ajax('Login::onSocialiteLogin', {
        data: { driver: 'google' },
        beforeSend() {
          that.waiting();
        },
      });
    });

    $('.link__logout').on('click', () => {
      oc.ajax('Logout::onAjax', {
        beforeSend() {
          that.waiting();
        },
        complete() {
          window.location.reload(true);
        },
      });
    });
  }

  waiting() {
    document.dispatchEvent(new Event(this.eventName, { bubbles: true }));
  }
}();
